// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import MintUI from "mint-ui";
import "mint-ui/lib/style.css";
import { Table, TableColumn, Pagination, DatePicker, Select, Input, Checkbox, Option, Button, Row, Col, Container,Main} from "element-ui";
import App from "./App";
import router from "./router";
import Qs from "qs";
import store from "./vuex/store"; // 引入store
import plus from "vue-h5-plus";
import VueClipboard from "vue-clipboard2";
import axios from "axios";
import moment from 'moment'

Vue.use(MintUI);
Vue.use(plus);
Vue.use(VueClipboard);

Vue.config.devtools = true;
Vue.config.productionTip = false;
// Vue.prototype.axios = axios
// axios.defaults.baseURL = '/api'
Vue.prototype.Qs = Qs;
Vue.prototype.Toast = MintUI.Toast;
Vue.prototype.MessageBox = MintUI.MessageBox;
Vue.prototype.Indicator = MintUI.Indicator;
Vue.prototype.$moment = moment;

Vue.component(MintUI.Popup.name, MintUI.Popup);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Pagination.name, Pagination);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Select.name, Select);
Vue.component(Input.name, Input);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Option.name, Option);
Vue.component(Button.name, Button);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Container.name, Container);
Vue.component(Main.name, Main);

/**
 * GET CONFIG
 */
axios({
  method: "get",
  baseURL: "../../static/words.json"
})
  .then(res => {
    
    store.commit("SetWordsConfig", res.data);
  })
  .catch(err => {
    console.warn(err);
  });

axios({
  method: "get",
  baseURL: "../../static/api.json"
})
  .then(res => {
    //console.log(res.data);
    store.commit("SetApiConfig", res.data);
  })
  .catch(err => {
    console.warn(err);
  });

axios({
    method: "get",
  baseURL: "../../static/gamelink.json"
  })
  .then(res => {
    //console.log(res.data);
    store.commit("SetGameLinkConfig", res.data);
  })
  .catch(err => {
    console.warn(err);
  });







/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js